import { render, staticRenderFns } from "./TheDrawer.vue?vue&type=template&id=bc51ac36&"
import script from "./TheDrawer.vue?vue&type=script&lang=js&"
export * from "./TheDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports